module.exports = __webpack_public_path__ + "static/media/info_icon.6ee9aaf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_icon.svg
// module id = 30
// module chunks = 0